// extracted by mini-css-extract-plugin
export default {"page":"RowMaterialPage_page__KB5bb"};